import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMenu, FiX, FiZap } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const phoneNumber = "251-522-9131";

  const handleLogoClick = (e) => {
    e.preventDefault();
    window.location.href = '/';
    window.location.reload();
  };

  const scrollToSection = (id) => {
    setIsMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const navLinks = [
    { label: "The Benefits", id: "benefits" },
    { label: "The Process", id: "process" },
    { label: "Success Stories", id: "testimonials" }
  ];

  return (
    <motion.header 
      className="bg-white shadow-lg fixed w-full top-0 z-50"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <button 
              onClick={handleLogoClick}
              className="text-2xl font-bold text-gray-900 flex items-center tracking-tighter hover:opacity-80 transition-opacity"
            >
              <span className="text-red-600">cash</span>x24.com
            </button>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="text-gray-700 hover:text-red-600 font-bold transition-colors"
              >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <button
              onClick={() => scrollToSection('get-offer')}
              className="flex items-center space-x-2 bg-gray-900 text-white px-5 py-3 rounded-lg font-bold hover:bg-black transition-colors shadow-md"
            >
              <SafeIcon icon={FiZap} className="w-5 h-5 text-red-500" />
              <span>Get Cash Offer</span>
            </button>

            <motion.a
              href={`tel:${phoneNumber}`}
              className="flex items-center space-x-2 bg-red-600 text-white px-5 py-3 rounded-lg font-bold hover:bg-red-700 transition-colors shadow-md border-2 border-red-600"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <SafeIcon icon={FiPhone} className="w-5 h-5" />
              <span>{phoneNumber}</span>
            </motion.a>
          </div>

          <button className="md:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6 text-gray-700" />
          </button>
        </div>

        <AnimatePresence>
          {isMenuOpen && (
            <motion.div 
              className="md:hidden py-4 border-t border-gray-200"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
            >
              <nav className="flex flex-col space-y-4 px-2">
                {navLinks.map((link) => (
                  <button
                    key={link.id}
                    onClick={() => scrollToSection(link.id)}
                    className="text-left text-gray-700 font-bold block py-2 hover:text-red-600 border-b border-gray-50"
                  >
                    {link.label}
                  </button>
                ))}
                <div className="flex flex-col gap-3 pt-4">
                  <button
                    onClick={() => scrollToSection('get-offer')}
                    className="flex items-center justify-center space-x-2 bg-gray-900 text-white py-4 rounded-lg font-bold"
                  >
                    <SafeIcon icon={FiZap} className="w-5 h-5 text-red-500" />
                    <span>Get Your Cash Offer</span>
                  </button>
                  <a href={`tel:${phoneNumber}`} className="flex items-center justify-center space-x-2 bg-red-600 text-white py-4 rounded-lg font-bold">
                    <SafeIcon icon={FiPhone} className="w-5 h-5" />
                    <span>Call Tyler: {phoneNumber}</span>
                  </a>
                </div>
              </nav>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.header>
  );
};

export default Header;